import { css } from 'styled-components';
export var highContrast = function highContrast(innerCss) {
  return css(["@media (forced-colors:active){", ";}"], innerCss);
};
export var highContrastTheme = function highContrastTheme(theme, innerCss) {
  return css(["@media (forced-colors:active) and (prefers-color-scheme:", "){", ";}"], theme, innerCss);
};
export var highContrastOutline = /*#__PURE__*/css(["outline:2px solid transparent;"]);
export var highContrastGrayColor = /*#__PURE__*/css(["color:GrayText;"]);
export var highContrastBorder = /*#__PURE__*/css(["border:1px solid transparent;"]);
export var highContrastBorder2 = /*#__PURE__*/css(["border:2px solid transparent;"]);